const featherIcons = require("feather-icons");

(function () {

    function initMetisMenu() {
        // MetisMenu js
        document.addEventListener("DOMContentLoaded", function (event) {
            if (document.getElementById("side-menu"))
                new MetisMenu('#side-menu');
        });
    }

    function initCounterNumber() {
        var counter = document.querySelectorAll('.counter-value');
        var speed = 250; // The lower the slower
        counter && counter.forEach(function (counter_value) {
            function updateCount() {
                var target = +counter_value.getAttribute('data-target');
                var count = +counter_value.innerText;
                var inc = target / speed;
                if (inc < 1) {
                    inc = 1;
                }
                // Check if target is reached
                if (count < target) {
                    // Add inc to count and output in counter_value
                    counter_value.innerText = (count + inc).toFixed(0);
                    // Call function every ms
                    setTimeout(updateCount, 1);
                } else {
                    counter_value.innerText = target;
                }
            };
            updateCount();
        });
    }

    function initLeftMenuCollapse() {
        var currentSIdebarSize = document.body.getAttribute('data-sidebar-size');
        window.onload = function () {
            if (window.innerWidth >= 1024 && window.innerWidth <= 1366) {
                document.body.setAttribute('data-sidebar-size', 'sm');
                updateRadio('sidebar-size-small')
            }
        }
        var verticalButton = document.getElementsByClassName("vertical-menu-btn");
        for (var i = 0; i < verticalButton.length; i++) {
            (function (index) {
                verticalButton[index] && verticalButton[index].addEventListener('click', function (event) {
                    event.preventDefault();
                    document.body.classList.toggle('sidebar-enable');
                    if (window.innerWidth >= 992) {
                        if (currentSIdebarSize == null) {
                            (document.body.getAttribute('data-sidebar-size') == null || document.body.getAttribute('data-sidebar-size') == "lg") ? document.body.setAttribute('data-sidebar-size', 'sm') : document.body.setAttribute('data-sidebar-size', 'lg')
                        } else if (currentSIdebarSize == "md") {
                            (document.body.getAttribute('data-sidebar-size') == "md") ? document.body.setAttribute('data-sidebar-size', 'sm') : document.body.setAttribute('data-sidebar-size', 'md')
                        } else {
                            (document.body.getAttribute('data-sidebar-size') == "sm") ? document.body.setAttribute('data-sidebar-size', 'lg') : document.body.setAttribute('data-sidebar-size', 'sm')
                        }
                    } else {
                        initMenuItemScroll();
                    }
                });
            })(i);
        }
    }

    function initMenuItemScroll() {
        setTimeout(function () {
            var sidebarMenu = document.getElementById("side-menu");
            if (sidebarMenu) {
                var activeMenu = sidebarMenu.querySelector(".mm-active .active");
                var offset = (activeMenu) ? activeMenu.offsetTop : 0;
                if (offset > 300) {
                    offset = offset - 100;
                    var verticalMenu = (document.getElementsByClassName("vertical-menu")) ? document.getElementsByClassName("vertical-menu")[0] : '';
                    if (verticalMenu && verticalMenu.querySelector(".simplebar-content-wrapper")) {
                        setTimeout(function () {
                            verticalMenu.querySelector(".simplebar-content-wrapper").scrollTop = offset;
                        }, 0);
                    }
                }
            }
        }, 0);
    }


    function initDropdownMenu() {
        if (document.getElementById("topnav-menu-content")) {
            var elements = document.getElementById("topnav-menu-content").getElementsByTagName("a");
            for (var i = 0, len = elements.length; i < len; i++) {
                elements[i].onclick = function (elem) {
                    if (elem.target.getAttribute("href") === "#") {
                        elem.target.parentElement.classList.toggle("active");
                        elem.target.nextElementSibling.classList.toggle("show");
                    }
                }
            }
            window.addEventListener("resize", updateMenu);
        }
    }

    function updateMenu() {
        var elements = document.getElementById("topnav-menu-content").getElementsByTagName("a");
        for (var i = 0, len = elements.length; i < len; i++) {
            if (elements[i].parentElement.getAttribute("class") === "nav-item dropdown active") {
                elements[i].parentElement.classList.remove("active");
                elements[i].nextElementSibling.classList.remove("show");
            }
        }
    }

    function initComponents() {
        // tooltip
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        });

        // popover
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
            return new bootstrap.Popover(popoverTriggerEl)
        });

        // toast
        var toastElList = [].slice.call(document.querySelectorAll('.toast'))
        var toastList = toastElList.map(function (toastEl) {
            return new bootstrap.Toast(toastEl)
        })
    }

    function fadeOutEffect(elem, delay) {
        var fadeTarget = document.getElementById(elem);
        fadeTarget.style.display = 'block';
        var fadeEffect = setInterval(function () {
            if (!fadeTarget.style.opacity) {
                fadeTarget.style.opacity = 1;
            }
            if (fadeTarget.style.opacity > 0) {
                fadeTarget.style.opacity -= 0.2;
            } else {
                clearInterval(fadeEffect);
                fadeTarget.style.display = 'none';
            }
        }, 200);
    }

    function initPreloader() {
        window.onload = function () {
            if (document.getElementById("preloader")) {
                fadeOutEffect('pre-status', 300);
                fadeOutEffect('preloader', 400);
            }
        }
    }

    function updateRadio(radioId) {
        if (document.getElementById(radioId))
            document.getElementById(radioId).checked = true;
    }

    function setTheme(theme){
        axios.post('/theme', {
            theme: theme,
        }).catch(function (error) {
                console.log(error);
            });
    }

    function layoutSetting() {

        var body = document.getElementsByTagName("body")[0];

        if(body.hasAttribute("data-layout-mode") && body.getAttribute("data-layout-mode") == "dark" ){
            updateRadio('layout-mode-dark')
        }else{
            updateRadio('layout-mode-light');
        }

        if(body.hasAttribute("data-layout-size") && body.getAttribute("data-layout-size") == "boxed") {
            updateRadio('layout-width-boxed');
        }else {
            updateRadio('layout-width-fluid');
        }


        // document.getElementById('theme-toggle').addEventListener('click', function (e) {
        //     console.log('ran 2');
        //     document.getElementById("icono").innerHTML = `<i id="icono" class="icon-sm" data-feather="sun"></i>`;
        //     featherIcons.replace();
        // });

        document.getElementById("theme-toggle").addEventListener("click", function (e){
            let theme = document.getElementById('theme-value').dataset;
            if (theme && theme.theme) {
                if (theme.theme == "light") {
                    setTheme(1);
                    theme.theme = 'dark';
                    document.getElementById("icono").innerHTML = `<i id="icono" class="icon-sm" data-feather="moon"></i>`;
                    featherIcons.replace();
                    document.body.setAttribute('data-layout-mode', 'light');
                    document.body.setAttribute('data-topbar', 'light');
                    document.body.setAttribute('data-sidebar', 'light');
                } else {
                    setTheme(0);
                    theme.theme = 'light';
                    document.getElementById("icono").innerHTML = `<i id="icono" class="icon-sm" data-feather="sun"></i>`;
                    featherIcons.replace();
                    document.body.setAttribute('data-layout-mode', 'dark');
                    document.body.setAttribute('data-topbar', 'dark');
                    document.body.setAttribute('data-sidebar', 'dark');

                }
            }
        });

    }

    function initCheckAll() {
        var checkAll = document.getElementById("checkAll");
        if (checkAll) {
            checkAll.onclick = function () {
                var checkboxes = document.querySelectorAll('.table-check input[type="checkbox"]');
                for (var i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = this.checked;
                }
            }
        }
    }

    function init() {
        initPreloader();
        initMetisMenu();
        initCounterNumber();
        initLeftMenuCollapse();
        initDropdownMenu();
        initComponents();
        layoutSetting();
        initMenuItemScroll();
        initCheckAll();
    }

    init();

})();


